import store from '@/store';
import router, { getRouteToStartSession } from '@/router';

function evalAndPrepareToRoute(signInData) {
  if (signInData.needsRedefinePassword) {
    store.dispatch('setTemporaryAccessData', {
      ...signInData,
    });
    return {
      name: 'temporary-access',
    };
  }
  if (!signInData.licenseAccepted) {
    return { name: 'software-license-text' };
  }
  return getRouteToStartSession();
}

export default {
  proceedAfterLogin(signInData) {
    router.push(evalAndPrepareToRoute(signInData));
  },
};
